import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';
import { compose } from 'redux';

import { withIntl } from 'HOC/withIntl';
import shouldSubmit from 'utilities/shouldSubmit';
import getDefaultLanguageRequiredFieldsErrors from 'utilities/getDefaultLanguageRequiredFieldsErrors';

import InfoForm from '../../components/InfoForm';

import { updateInfoRequest } from '../../services/actions';
import { selectInfoForUpdate } from '../../services/selectors';
import { forms, localizableInfoFields, requiredInfoFields } from '../../services/config';

const form = forms.updateInfoForm;

const validate = (values, { intl }) =>
    getDefaultLanguageRequiredFieldsErrors(values, requiredInfoFields, intl.formatMessage({ id: 'error.required' }));

const onSubmit = (data, dispatch, { intl, id, categoryId }) => {
    const confirmMessage = intl.formatMessage({ id: 'alert.submit.warn' });
    if (shouldSubmit(data, localizableInfoFields, confirmMessage)) {
        dispatch(updateInfoRequest(form, id, categoryId, data));
    }
};

export default compose(
    withIntl,
    connect((state, { id }) => ({
        initialValues: selectInfoForUpdate(state, { id }),
    })),
    reduxForm({
        form,
        validate,
        onSubmit,
        enableReinitialize: true,
    }),
)(InfoForm);
